const isPositiveId = (id) => {
  const num = Number(id);
  return Number.isFinite(num) && num > 0;
};

const isFilledText = (value) => value !== null && value !== undefined && String(value).trim() !== '';

// ÐÐ¾Ð»Ñ, Ð±ÐµÐ· ÐºÐ¾ÑÐ¾ÑÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð½ÐµÐ»ÑÐ·Ñ Ð´Ð¾Ð±Ð°Ð²Ð¸ÑÑ Ð² ÑÐ´ÐµÐ»ÐºÑ (Ð½ÑÐ¶Ð½Ñ Ð±Ð°Ð½ÐºÐ°Ð¼/Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐ°Ð¼).
export const CAR_REQUIRED_FIELDS = [
  {
    label: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
    isMissing: (car) => !isPositiveId(car?.complectationId) && !isPositiveId(car?.complectation?.id),
  },
  {
    label: 'ÐÐ±ÑÐµÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ',
    isMissing: (car) => !isFilledText(car?.engine_volume),
  },
  {
    label: 'Ð¢Ð¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ',
    // Ð¢Ð¸Ð¿ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ Ð±ÐµÑÐµÑÑÑ Ð¸Ð· ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ð¸, Ð¾ÑÐ´ÐµÐ»ÑÐ½Ð¾ Ð½Ð° Ð°Ð²ÑÐ¾ Ð½Ðµ ÑÑÐ°Ð½Ð¸ÑÑÑ.
    isMissing: (car) => !isFilledText(car?.complectation?.engine?.title) && !isPositiveId(car?.complectation?.engine?.id),
  },
  {
    label: 'Ð¢Ð¸Ð¿ ÐºÐ¾ÑÐ¾Ð±ÐºÐ¸ Ð¿ÐµÑÐµÐ´Ð°Ñ',
    isMissing: (car) =>
      !isPositiveId(car?.transmissionId) && !isPositiveId(car?.transmission?.id) && !isFilledText(car?.transmission),
  },
];

const getCarMissingFields = (car) => CAR_REQUIRED_FIELDS.filter((field) => field.isMissing(car)).map((field) => field.label);

export default getCarMissingFields;
